<template>
  <div class="border mt-4">
    <list
      title_add="Добавить услугу в заказ"
      title_add_key="add_service"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="false"
      :itemLink="itemLink"
      :setLink="setLink"
      :fields="fields"
      :searchDisable="true"
      :openItem="true"
      :params="params"
      @updated="$emit('updated', true)"
      @added="$emit('added', true)"
      :isAdd="true"
      @change="change"
      @input="change"
      @changeFunction="changeFunction"
      @deleted="$emit('deleted', true)"
      v-model="val"
    />
  </div>
</template>
<script>
export default {
  name: "products",
  props: {
    id: {
      default: null,
    },
  },
  created() {
    this.itemLink = `order_services`;
    this.setLink = `order_services`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {
        order_id: this.id,
      },
      val: [],
      modalCreate: "purchase",
      fields: [
        {
          label: "Услуга",
          labelKey: "service",
          key: "service",
          type: "select-full",
          modal: "service",
          fieldKey: "id",
          selectKey: "name",
          params: { type_object: "1" },
        },

        {
          label: "",
          key: "order_id",
          type: "hidden",
          default: this.id,
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_order_service",
      itemLink: "orders",
      setLink: "orders",
      columns: [
        {
          key: "id",
          title: "ID",
        },
        {
          key: "service",
          title: "Услуга",
          object: "name",
          disableLink: true,
        },
        // {
        //   key: "display_status",
        //   title: "Статус",
        // },
        // {
        //   key: "model",
        //   title: "Товар",
        //   object: "name",
        //   disableLink: true,
        // },
        // {
        //   key: "model",
        //   title: "Цена",
        //   object: "price",
        //   disableLink: true,
        //   price: true,
        // },
        // {
        //   detail: true,
        //   // remove: true,
        // },
      ],
    };
  },
};
</script>
